module.exports = "/packs/images/svg/facilities/bowling~bf9ae900be5bedd6b5dcb016e201d4ec.svg";